import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../services/api";
import AppLayout from "../layout/AppLayout";

export default function ClientesDetalhe() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [cliente, setCliente] = useState(null);
  const [processos, setProcessos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    api.get(`/clientes_detalhe.php?id=${id}`)
      .then(res => {
        setCliente(res.data.cliente);
        setProcessos(res.data.processos || []);
      })
      .catch(() => {
        alert("Cliente não encontrado");
        navigate("/app/admin/clientes");
      })
      .finally(() => setLoading(false));
  }, [id, navigate]);

  if (loading) {
    return (
      <AppLayout title="Cliente">
        <p className="text-slate-400">Carregando...</p>
      </AppLayout>
    );
  }

  return (
    <AppLayout
      title={cliente.nome}
      subtitle={cliente.email}
    >

      {/* AÇÕES */}
      <div className="mb-6 flex gap-3">
        <button
          onClick={() => navigate(`/app/admin/processos/novo?cliente=${id}`)}
          className="rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold"
        >
          + Novo processo
        </button>
      </div>

      {/* PROCESSOS */}
      <div className="rounded-xl border border-[#1f2937] bg-[#121826] p-4">
        <h3 className="mb-4 font-semibold text-slate-100">
          Processos do cliente
        </h3>

        {processos.length === 0 && (
          <p className="text-sm text-slate-400">
            Nenhum processo cadastrado.
          </p>
        )}

        <ul className="space-y-3">
          {processos.map(p => (
            <li
              key={p.id}
              onClick={() => navigate(`/app/admin/processos/${p.id}`)}
              className="cursor-pointer rounded-lg border border-[#1f2937] p-3 hover:bg-slate-800/50"
            >
              <p className="text-sm font-medium text-slate-100">
                {p.numero || "Processo interno"}
              </p>
              <p className="text-xs text-slate-400">
                {p.vara} • {p.status}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </AppLayout>
  );
}
